import { render, staticRenderFns } from "./surfaces_page.vue?vue&type=template&id=1111ad1a"
import script from "./surfaces_page.js?vue&type=script&lang=js&external"
export * from "./surfaces_page.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports